import React, { useEffect, useState } from "react";
import { Button, Card } from "antd";
import { useTranslation } from "react-i18next";
import { useOrderDeliveries } from "../../../../../data/hooks/firestore/useOrderDeliveries";
import { SOO_COOL_DELIVERY_LABELS } from "../../../../../constants/OrderConstant";
import DonutChart from "../../../../../components/shared-components/DonutChart";
import { COLOR_1, COLOR_2, COLOR_3, COLOR_4 } from "../../../../../constants/ChartConstant";
import { useNavigate, useSearchParams } from "react-router-dom";
import { deliveriesReportSooCool } from "../../../../../urls";

const DeliveryStatistics = ({ orders, dateRange, dateRangeText }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { data: deliveries, loading, error } = useOrderDeliveries(dateRange);
  const [stats, setStats] = useState({
    onTime: 0,
    late: 0,
    early: 0,
    pending: 0,
    total: 0,
  });

  useEffect(() => {
    if (deliveries && orders) {
      // Filter deliveries for SooCool orders only (including pending)
      const sooCoolDeliveries = deliveries.filter((delivery) => {
        const order = orders.find((o) => o.id === delivery.orderId);
        if (!order || order.farmorderStatus === "canceled") return false;
        return order && SOO_COOL_DELIVERY_LABELS.includes(order.deliveryLabel);
      });

      // Calculate statistics
      const onTime = sooCoolDeliveries.filter((d) => d.deliveryStatus === "on_time").length;
      const late = sooCoolDeliveries.filter((d) => d.deliveryStatus === "late").length;
      const early = sooCoolDeliveries.filter((d) => d.deliveryStatus === "early").length;
      const pending = sooCoolDeliveries.filter((d) => d.deliveryStatus === "pending").length;

      setStats({
        onTime,
        late,
        early,
        pending,
        total: sooCoolDeliveries.length,
      });
    }
  }, [deliveries, orders]);

  const handleSeeFullReport = () => {
    const currentParams = searchParams.toString();
    navigate(`${deliveriesReportSooCool}${currentParams ? `?${currentParams}` : ""}`);
  };

  const chartData = {
    series: [stats.onTime, stats.late, stats.early, stats.pending],
    labels: [t("on_time"), t("late"), t("early"), t("pending")],
    colors: [COLOR_2, COLOR_3, COLOR_4, COLOR_1],
  };

  return (
    <Card
      title={t("soocool_delivery_performance")}
      extra={
        <Button type="link" onClick={handleSeeFullReport}>
          {t("see_full_report")}
        </Button>
      }
      loading={loading}
    >
      <span className="text-muted">{dateRangeText}</span>

      <div style={{ textAlign: "center", marginTop: 16 }}>
        <h2 className="font-weight-bold mb-0">{stats.total}</h2>
        <span className="text-muted">{t("total_deliveries")}</span>
      </div>

      {stats.total > 0 ? (
        <DonutChart series={chartData.series} labels={chartData.labels} colors={chartData.colors} height={240} />
      ) : (
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <span className="text-muted">{t("no_data_available")}</span>
        </div>
      )}
    </Card>
  );
};

export default DeliveryStatistics;
